import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {register, register as registerSwiperElements} from 'swiper/element/bundle';

registerSwiperElements();
register();
platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
